module.exports = __webpack_public_path__ + "static/img/09.b3407fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250403/09.png
// module id = 97nv
// module chunks = 0